export default __webpack_public_path__ + "static/media/lee_pcr_product_l.abbf6add.svg";